import React, { useRef, useEffect } from "react";
import "./IssueSummaryModal.css";

const IssueSummaryModal = ({ isOpen, onClose, issueSummary }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener to document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="issue-summary-modal">
      <div className="modal-content" ref={modalRef}>
        <span
          className="close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 20,
            cursor: "pointer",
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          &times;
        </span>
        <h1 className="text-lg font-bold pt-1">Issue Summary</h1>
        {issueSummary.length === 0 ? (
          <p>No issue details available.</p>
        ) : (
          <div className="overflow-y-auto overflow-x-auto max-h-[70vh] pt-6">
            <ul>
              {issueSummary.map((issue, index) => (
                <li key={index}>
                  <p>
                    <strong>Issue Type:</strong> {issue.issue_type}
                  </p>
                  <p>
                    <strong>Repeated Tickets:</strong>{" "}
                    {issue.repeated_ticket_count}
                  </p>
                  <p>
                    <strong>Total Tickets:</strong> {issue.total_tickets}
                  </p>
                  <p>
                    <strong>Percentage:</strong> {issue.percentage}%
                  </p>
                  <hr />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default IssueSummaryModal;
